import React from "react";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";
import { Alert, Grid, List, Typography } from "@mui/material";
import { useState } from "react";
import { UpdatepasswordApi } from "backendServices/ApiCalls";
import * as yup from "yup";
import { Form, Formik } from "formik";
import Div from "@jumbo/shared/Div/Div";
import JumboTextField from "@jumbo/components/JumboFormik/JumboTextField";
import { LoadingButton } from "@mui/lab";
import { useTranslation } from "react-i18next";
import {
  getPasswordResetErrorMessage,
  PASSWORD_POLICY_HELP,
  passwordValidationSchema,
} from "app/pages/auth-pages/reset-password/resetPasswordPolicy";

export const updateLoginPasswordValidationSchema = yup.object({
  old_login_password: yup
    .string()
    .strict(true)
    .typeError("Old password must be a string")
    .required("Old password is required"),
  new_login_password: passwordValidationSchema,
  confirmpassword: yup
    .string()
    .strict(true)
    .typeError("Confirm password must be a string")
    .oneOf([yup.ref("new_login_password"), null], "Passwords must match")
    .required("Confirm password is required"),
});

const Updateloginpassword = () => {
  const { t } = useTranslation();
  const [alertData, setalertData] = useState({
    show: false,
    message: "",
    severity: "error",
  });

  const finishWithError = (responseOrError, setSubmitting) => {
    setalertData({
      show: true,
      message: getPasswordResetErrorMessage(responseOrError),
      severity: "error",
    });
    setSubmitting(false);
  };

  const handleSubmit = (data, setSubmitting, resetForm) => {
    setalertData({ show: false, message: "", severity: "error" });

    const params = {
      oldpassword: data.old_login_password,
      newpassword: data.new_login_password,
    };

    UpdatepasswordApi(
      params,
      (response) => {
        if (response?.data?.status === "error") {
          finishWithError(response, setSubmitting);
        } else if (response?.data?.status === "success") {
          setalertData({
            show: true,
            message: response?.data?.message,
            severity: "success",
          });
          setSubmitting(false);
          resetForm();
        } else {
          finishWithError(response, setSubmitting);
        }
      },
      (error) => finishWithError(error, setSubmitting)
    );
  };

  return (
    <Grid
      container
      fullWidth
      sm={12}
      xs={12}
      p={2}
      alignItems="center"
      justifyContent="center"
    >
      <Grid item sm={6} xs={12}>
        <JumboCardQuick title={t("pages.title.loginpassword")} noWrapper>
          {alertData.show && (
            <Alert
              severity={alertData.severity}
              role="alert"
              onClose={() =>
                setalertData({ show: false, message: "", severity: "error" })
              }
              sx={{ m: 2, mb: 0 }}
            >
              {alertData.message}
            </Alert>
          )}
          <List disablePadding sx={{ mb: 2 }}>
            <Formik
              validateOnChange={true}
              initialValues={{
                old_login_password: "",
                new_login_password: "",
                confirmpassword: "",
              }}
              validationSchema={updateLoginPasswordValidationSchema}
              onSubmit={(data, { setSubmitting, resetForm }) => {
                setSubmitting(true);
                handleSubmit(data, setSubmitting, resetForm);
              }}
            >
              {({ isSubmitting }) => (
                <Form
                  style={{ textAlign: "left" }}
                  noValidate
                  autoComplete="off"
                >
                  <Div sx={{ mt: 1, mb: 3, pl: 2, pr: 2 }}>
                    <JumboTextField
                      fullWidth
                      name="old_login_password"
                      label="Old Password"
                      type="password"
                      autoComplete="current-password"
                      required
                    />
                  </Div>

                  <Div sx={{ mt: 1, mb: 3, pl: 2, pr: 2 }}>
                    <JumboTextField
                      fullWidth
                      id="new-login-password"
                      name="new_login_password"
                      label="New Password"
                      type="password"
                      autoComplete="new-password"
                      required
                      inputProps={{
                        "aria-describedby":
                          "update-password-policy-help new-login-password-helper-text",
                      }}
                    />
                    <Typography
                      id="update-password-policy-help"
                      variant="body2"
                      sx={{ mt: 1, color: "text.secondary" }}
                    >
                      {PASSWORD_POLICY_HELP}
                    </Typography>
                  </Div>

                  <Div sx={{ mt: 1, mb: 3, pl: 2, pr: 2 }}>
                    <JumboTextField
                      fullWidth
                      id="new-login-password-confirmation"
                      name="confirmpassword"
                      label="Confirm Password"
                      type="password"
                      autoComplete="new-password"
                      required
                    />
                  </Div>

                  <Div sx={{ mt: 1, pl: 2, pr: 2 }}>
                    <LoadingButton
                      fullWidth
                      type="submit"
                      variant="contained"
                      size="large"
                      sx={{ mb: 3 }}
                      loading={isSubmitting}
                    >
                      {t("pages.title.submit")}
                    </LoadingButton>
                  </Div>
                </Form>
              )}
            </Formik>
          </List>
        </JumboCardQuick>
      </Grid>
    </Grid>
  );
};

export default Updateloginpassword;
